export const clamp = (value, min, max) => {
  if (value < min) return min;
  if (value > max) return max;
  return value;
};

export const clamp01 = (value) => {
  if (value < 0) return 0;
  if (value > 1) return 1;
  return value;
};

export const lerpf = (a, b, t) => a + (b - a) * t;
export const lerp = (a, b, t) => {
  if (t <= 0) return a;
  if (t >= 1) return b;
  return a + (b - a) * t;
};
